import { AppDomainConfig } from "../../envConfig";
import { IndustryEnum } from "../../types/api-schema";

import colors from "./colors";
import iconCategories from "./icons.json";

const config: Partial<AppDomainConfig> = {
  domains: ["io"],
  font: "16px arial",
  iconCategories,
  id: "rheinbahn",
  industry: IndustryEnum.Transport,
  name: "Rheinbahn",
  slug: "rheinbahn",
  ...colors,
};
export default config;
